<template>
  <v-card class="movements-cash">
    <v-tabs
      v-model="currentItem"
      fixed-tabs
      :centered="true"
      :active-class="'selected-tab-cash'"
      @change="handleSelectTab"
    >
      <v-tab v-for="item in items" :key="item.id" :href="'#tab-' + item.id">
        {{ item.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentItem">
      <v-tab-item
        v-for="item in items"
        :key="item.id"
        :value="'tab-' + item.id"
      >
        <v-card flat>
          <v-simple-table class="wost-table-detail" height="58vh">
            <thead class="debt-header-payment">
              <tr>
                <th class="text-left" v-if="selectedTab == 'tab-tarjeta'">
                  Tarjeta
                </th>
                <th class="text-left">Hora</th>
                <th class="text-left">Monto</th>
                <th class="text-left">Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="movement in cashData" :key="movement.id">
                <td v-if="selectedTab == 'tab-tarjeta'">
                  {{ movement.payment_method }}
                </td>
                <td>{{ movement.register_date | moment("h:mm a") }}</td>
                <td v-if="currentItem == 'tab-egresos'">
                  <span class="amount-cash-expense">{{
                    movement.amount | currency("S/")
                  }}</span>
                </td>
                <td v-else>
                  <span class="amount-cash-income">{{
                    movement.amount | currency("S/")
                  }}</span>
                </td>
                <td
                  v-if="
                    selectedTab == 'tab-cash' || selectedTab == 'tab-tarjeta'
                  "
                >
                  Orden {{ movement.order_id | numberOrder }}
                </td>
                <td v-else>
                  {{ movement.description }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "Detail",
  data() {
    return {
      currentItem: "tab-ingresos",
      selectedTab: "tab-ingresos",
      items: [
        {
          id: "ingresos",
          title: "Ingresos de caja",
        },
        {
          id: "egresos",
          title: "Egresos de caja",
        },
        {
          id: "cobros",
          title: "Cobros de deudas",
        },
        {
          id: "cash",
          title: "Cash",
        },
        {
          id: "tarjeta",
          title: "Tarjeta",
        },
        {
          id: "yape",
          title: "Yape",
        },
        {
          id: "plin",
          title: "PLIN",
        },
        {
          id: "transferencia",
          title: "TRANSFERENCIA",
        },
        {
          id: "saldo",
          title: "Saldo a favor",
        },
      ],
      text: "",
      dataCash: [],
      list_cash: [],
      list_cards: [],
      list_payments_debts: [],
      total_sale: 0,
      total_payments_debts: 0,
    };
  },
  computed: {
    ...mapState("cash", [
      "cashCurrent",
      "cashData",
      "incomes",
      "expenses",
      "payments",
      "salesCash",
      "salesCards",
      "balanceFavors",
      "totalIncomes",
      "totalExpenses",
      "totalPayments",
      "totalSalesCash",
      "totalSalesCards",
      "totalSales",
      "cashSelected",
    ]),
  },
  methods: {
    ...mapActions("cash", [
      "getCashCurrent",
      "getPayments",
      "getSalesCash",
      "getSalesCards",
      "getIncomes",
      "getExpenses",
      "getTotalAmount",
      "getBalanceFavor",
      "selectCash",
      "getSalesPlins",
      "getSalesYapes",
      "getSalesTransferencias",
    ]),
    restartTab() {
      this.currentItem = "tab-ingresos";
      this.selectedTab = "tab-ingresos";
    },
    handleSelectTab(value) {
      this.selectedTab = value;
      this.dataCash = [];
      if (value == "tab-cobros") {
        this.getDataPayments();
      } else if (value == "tab-cash") {
        this.getDataSalesCash();
      } else if (value == "tab-tarjeta") {
        this.getDataSalesCards();
      } else if (value == "tab-yape") {
        this.getDataSalesYapes();
      } else if (value == "tab-plin") {
        this.getDataSalesPlins();
      } else if (value == "tab-transferencia") {
        this.getDataSalesTransferencia();
      } else if (value == "tab-ingresos") {
        this.getDataIncomes();
      } else if (value == "tab-egresos") {
        this.getDataExpenses();
      } else if (value == "tab-saldo") {
        this.getDataBalanceFavors();
      }
      //this.getTotalAmount()
    },
    getDataPayments() {
      this.getPayments(this.cashSelected.id);
    },
    getDataSalesCash() {
      this.getSalesCash(this.cashSelected.id);
    },
    getDataSalesCards() {
      this.getSalesCards(this.cashSelected.id);
    },
    getDataSalesYapes() {
      this.getSalesYapes(this.cashSelected.id);
    },
    getDataSalesPlins() {
      this.getSalesPlins(this.cashSelected.id);
    },
    getDataSalesTransferencia() {
      this.getSalesTransferencias(this.cashSelected.id);
    },
    getDataIncomes() {
      this.getIncomes(this.cashSelected.id);
    },
    getDataExpenses() {
      this.getExpenses(this.cashSelected.id);
    },
    getDataBalanceFavors() {
      this.getBalanceFavor(this.cashSelected.id);
    },
    async loadSelectCash() {
      await this.getCashCurrent();
      this.selectCash(this.cashCurrent);
      if (this.cashSelected) {
        this.getDataIncomes(this.cashSelected.id);
      }
    },
  },
  mounted() {
    this.loadSelectCash();
  },
};
</script>

<style>
.movements-cash {
  height: 65vh;
}

.selected-tab-cash {
  background-color: #3f51b5;
  color: white !important;
}

.amount-cash-income {
  color: #34b362;
  font-weight: 500;
}

.amount-cash-expense {
  color: #f96654;
  font-weight: 500;
}
</style>
